import { Component, OnInit, ElementRef, OnDestroy } from "@angular/core";
import { Location } from "@angular/common";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { AppState } from "app/reducers";
import { logout } from "app/modules/auth/_state/auth.actions";
import { AppLocalStorage } from "app/app-storage-manager/local-storage";
import { MiscService } from "app/shared/misc.service";
import { DashboardService } from "app/modules/dashboard/_services/dashboard.service";
import { AuthService } from "app/modules/auth/_services/auth.service";
import { SESSION_ROLE } from "app/modules/dashboard/_state/dashboard.interface";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
})
export class NavbarComponent implements OnInit, OnDestroy {
  listTitles: any[] = [];
  location: Location;
  mobile_menu_visible: any = 0;
  // public showChurchMenu = [
  //   "COUNTRY_ADMIN",
  //   "CHURCH_ADMIN",
  //   "AREA_ADMIN",
  //   "DISTRICT_ADMIN",
  // ];
  logout_dropdown: any;
  private toggleButton: any;
  mobileMenu: any;
  avatar: any;
  private sidebarVisible: boolean;
  public userData: any;
  user;
  name: string;
  managementTitle: string;
  showMenuItem: true;
  userRole: string;

  constructor(
    location: Location,
    private element: ElementRef,
    public router: Router,
    private miscService: MiscService,
    private store: Store<AppState>,
    private appStorage: AppLocalStorage,
    private dashboardService: DashboardService,
    private authService: AuthService,
  ) {
    this.location = location;
    this.sidebarVisible = false;
    this.userData = this.miscService.getLoggedInUserDetails();
    // this.managementTitle = this.miscService.getManagementPageTitles();
    this.userRole = this.authService.getUserRole();
    if (
      this.userRole !== SESSION_ROLE.Cell_Minister ||
      this.userData?.clusterPastor
    ) {
      this.listTitles = [
        { path: "/app/dashboard/overview", title: "Overview" },
        {
          path: "",
          title: "Management",
          subMenu: this.miscService.getManagementSubMenus(),
        },
        // {path: "/app/dashboard/attendance", title: "Attendance"},
        { path: "/app/dashboard/broadcast", title: "Broadcast" },
        { path: "/app/dashboard/reports", title: "Reports" },
        { path: "/app/dashboard/media", title: "Media" },
        { path: "/app/dashboard/settings", title: "Settings" },
        { path: "/app/dashboard/jobs", title: "Jobs" },
      ];
    }
    if (this.userData?.clusterPastor) {
    this.listTitles = this.listTitles.filter(
      (item) =>
        item.title !== "Broadcast" && item.title !== "Media"
    );
  }
    // this.user = this.authService.getUserDetails();
  }

  ngOnInit() {
    this.mobileMenu = document.querySelector(".custom-absolute");
    this.avatar = document.querySelector(".custom-avatar");
    this.logout_dropdown = document.querySelector(".logout-dropdown");

    const navbar: HTMLElement = this.element.nativeElement;
    this.toggleButton = navbar.getElementsByClassName("navbar-toggler")[0];
    this.router.events.subscribe((event) => {
      const $layer: any = document.getElementsByClassName("close-layer")[0];
      if ($layer) {
        $layer.remove();
        this.mobile_menu_visible = 0;
      }
    });
  }
  ngOnDestroy() {
    //this.userSubcription.unsubscribe();
  }

  handleCloseMenu() {
    if (window.innerWidth <= 800) {
      this.mobileMenu.classList.toggle("show");
    } else {
      this.logout_dropdown.classList.toggle("display");
    }
  }

  onLogout() {
    this.store.dispatch(logout());
  }

  routeToComponent = (url: string) => {
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate([url]);
    });
  };
}
